module.exports = {
  name: '請假資料',
  schema: {
    type: 'Object',
    contents: {
      stafferRef: {
        type: 'ObjectId',
        name: '人員',
        reference: 'users',
        refKeys: ['name'],
      },
      type: {
        type: 'String',
        name: '假別',
        options: [
          '事假',
          '病假',
          '病假A',
          '特休',
          '公出',
          '遲到',
          '曠職',
          '婚假',
          '喪假',
          '育嬰假',
          '產假',
          '陪產假',
          '產檢假',
          '防疫照顧假',
          '疫苗接種假',
          '防疫隔離假',
        ],
      },
      start: {
        type: 'Date',
        name: '開始時間',
        format: 'YYYY/MM/DD HH:mm:ss',
        parseFormat: 'YYYYMMDDHHmmss',
        input: 'text',
      },
      end: {
        type: 'Date',
        name: '結束時間',
        format: 'YYYY/MM/DD HH:mm:ss',
        parseFormat: 'YYYYMMDDHHmmss',
        input: 'text',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'stafferRef', width: 100 },
        { key: 'type', width: 100 },
        { key: 'start', width: 200 },
        { key: 'end', width: 200 },
      ],
    },
    editor: {
      groups: [
        {
          name: '系統資料',
          rows: [
            [{ key: 'stafferRef' }],
            [{ key: 'type' }],
            [{ key: 'start' }],
            [{ key: 'end' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/leaveRecords.js